import React, { Fragment, useEffect, useState } from "react";
import { useAddBeacon, useEditBeacon } from "hooks/configuration/tag/tag"
import { Button, Row, Col, Form, Input, Select, message } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";

const FormTag = () => {

    let navigate = useNavigate();
    const [form] = Form.useForm();
    const editData = useLocation();
    const [serverErrors, setServerErrors] = useState({});

    const create = editData.pathname === "/configuration/tag/create";

    const status = [
        { 'label': "Active", "value": true },
        { 'label': "InActive", "value": false },
    ]

    const { mutate: addBeacon, isLoading: Loading } = useAddBeacon();
    const { mutate: editBeacon, isLoading: editLoading } = useEditBeacon();

    const onFinish = (formData) => {
        const trimmedValues = Object.keys(formData).reduce((acc, key) => {
            acc[key] = typeof formData[key] === 'string' ? formData[key].trim() : formData[key];
            return acc;
        }, {});
        if (create) {
            addBeacon(trimmedValues, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message.success(item?.message);
                        navigate("/configuration/tag");
                    } else {
                        message.error(item?.data);
                    }

                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                    } 
                }
            })
        } else {
            editBeacon(trimmedValues, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message.success(item?.message);
                        navigate("/configuration/tag");
                    } else {
                        message.error(item?.message);
                    }
                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                        if (errorMessages?.Tag?.[0]) {
                            message.error(errorMessages.Tag[0]);
                        }
                    }
                }
            })
        }
    }

    const onChangeHandler = (value) => {
        form.setFieldsValue({ "active": value })
    }
    const clearError = (name) => {
        setServerErrors(prev => ({ ...prev, [name]: "" }));
    };

    useEffect(() => {
        if (!create) {
            form.setFieldsValue({
                "tagId": editData?.state?.tagId,
                "cardId": editData?.state?.cardId,
                "active": editData?.state?.status,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <Fragment>
            <div className="form-page">
                <div className="form-head form-head-sticky">
                    <div className="form-head-left">
                        <Link to="/configuration/tag" className="form-back">
                            <Image name="backArrow.svg" />
                        </Link>
                        <div className="form-title">
                            <h1>{create ? "New" : "Edit"} RFID Card</h1>
                            <p>{create ? "Register a tag / card so it can be assigned to an employee" : "Update this tag / card"}</p>
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="form-cancel" onClick={() => navigate("/configuration/tag")}>Cancel</Button>
                        <Button className="form-submit" loading={Loading || editLoading} onClick={() => form.submit()} htmlType="submit">
                            <Image className="save-img" name="save.svg" /> {create ? "Save" : "Update"}
                        </Button>
                    </div>
                </div>

                <div className="form-card">
                    <Form
                        form={form}
                        onFinish={onFinish}
                        colon={false}
                        layout="vertical">
                        <Form.Item name="tagId" hidden={true}>
                            <Input />
                        </Form.Item>

                        <section className="form-section">
                            <div className="form-section-head">
                                <h2>Card details</h2>
                                <p>The card identifier read by the gateways.</p>
                            </div>
                            <Row gutter={[24, 0]}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Card ID" name="cardId" rules={[{ required: true, message: "Enter the tag/card id" }, {
                                        pattern: /^[0-9a-zA-Z]+$/,
                                        message: "Special Characters and Space not allowed",
                                    }]}
                                        validateStatus={serverErrors?.CardId ? "error" : ""}
                                        help={serverErrors?.CardId?.[0]}
                                    >
                                        <Input placeholder="Enter the tag/card id" maxLength={50} onChange={() => clearError("CardId")} ></Input>
                                    </Form.Item>
                                </Col>
                                {create ? null : (
                                    <Col xs={24} sm={12} lg={6}>
                                        <Form.Item label="Status" name="active" rules={[{ required: true, message: 'Required!' }]}>
                                            <Select onChange={onChangeHandler} placeholder={"Select status"} options={status} />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        </section>
                    </Form>
                </div>
            </div>
        </Fragment>
    )
}
export default FormTag;